/********************************************
 * Ajax Insights
 ********************************************/
function fnAjaxPostsFilter(i, oSection) {
    //Vars
    var oPosts = $("#posts-container"),
        oInsightsBlock = $("#insights-feed"),
        oAjaxData = {
            action: "filter_posts",
            postsPerPage: oPosts.data("posts-per-page"),
            paged: 1,
        };

    //Ajax Call
    function ajax_filter_posts() {
        oInsightsBlock.addClass("is-loading");
        $.get(oAjax.sAjaxUrl, oAjaxData, function (response) {
            oPosts.html(response);
            fnCursor();
            oInsightsBlock.removeClass("is-loading");
        });
        // scrollTo();
        return false;
    }

    //On select change
    $(document).on("change", ".posts-sorting select", function (e) {
        var sSortBy = $(this).find("option:selected").data("order");
        oAjaxData.sort_by = sSortBy;
        ajax_filter_posts();
    });

    //Load more button click
    $(document).on("click", ".load-more-btn", function (e) {
        e.preventDefault();
        
        var iPostsShown = oPosts.find("article.post").length;
        oAjaxData.postsToShow = iPostsShown + oAjaxData.postsPerPage;

        ajax_filter_posts();
    });

    //filter by category
    $(document).on("click", ".filters-block > a", function (e) {
        e.preventDefault();

        oAjaxData.postsToShow = oAjaxData.postsPerPage;

        $(".filters-block a").removeClass("current");
        $(this).addClass("current");
        oAjaxData.chosenCat = $(this).data("term-id");
        ajax_filter_posts();

        window.innerWidth < 768 && scrollTo();
    });

    //Smooth Scroll
    function scrollTo() {
        $("html, body").animate(
            {
                scrollTop: oInsightsBlock.find(".container.posts").offset().top,
            },
            500
        );
    }

    //Mobile Filters Dropdown
    $(document).on("click", ".filters-mobile", function (e) {
        $(".filters-block").slideToggle("300");
        return false;
    });
}
